import { SelfServiceAPI } from 'types';

export const FILTER_OPTIONS: Array<{
  label: string;
  value: string;
  queryFilter: SelfServiceAPI.BookingListFilter;
}> = [
  {
    label: 'Upcoming',
    value: 'upcoming',
    queryFilter: SelfServiceAPI.BookingListFilter.UPCOMING,
  },
  {
    label: 'Past',
    value: 'past',
    queryFilter: SelfServiceAPI.BookingListFilter.PAST,
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
    queryFilter: SelfServiceAPI.BookingListFilter.CANCELLED,
  },
];

export const OPTIONS = FILTER_OPTIONS.map(({ label, value }) => ({ label, value }));
export const VALID_FILTERS = FILTER_OPTIONS.map(({ value }) => value);
export const DEFAULT_FILTER = FILTER_OPTIONS[0].value;
